<template>
  <div id="tablePage">
    <!-- 交收成交查询 -->
    <div class="orderTable">
      <el-table
        ref="tableData"
        :data="tableData"
        :height="tableHeight"
        :cell-class-name="directionClass"
        @sort-change="sortChange"
        v-loading="loading"
      >
        <template slot="empty" v-if="!loading">
          <div v-if="isNetWrong" class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data" style="margin-top: -15px !important; text-align: center;" @click="showData">加载失败,点击重试</div>
          </div>
          <div v-else class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data">暂无数据</div>
          </div>
        </template>
        <el-table-column prop="tradeId" label="交收单号">
        </el-table-column>
        <el-table-column prop="commodityName" label="商品名称">
        </el-table-column>
        <el-table-column prop="quantity" label="交收数量">
        </el-table-column>
        <el-table-column
          prop="tradeType"
          label="交收类型"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.tradeType | tradeTypeFormat }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="weight" label="交收重量">
          <template slot-scope="scope">
            {{ scope.row.weight }}
          </template>
        </el-table-column> -->
        <el-table-column prop="bsFlag" label="买|卖">
        </el-table-column>
        <!-- <el-table-column prop="deliveryType" label="交收类型">
        <template slot-scope="scope">
          {{ scope.row.deliveryType|deliveryTypeFormat }}
        </template>
      </el-table-column> -->
        <!-- <el-table-column prop="deliveryPrice" label="订立价">
          <template slot-scope="scope">

          </template>
        </el-table-column> -->
        <el-table-column prop="deliveryPrice" label="交收价格">
          <template slot-scope="scope">
            <span v-if="isHistory"> {{ Number(scope.row.cjjg).toFixed(scope.row.priceScale) }}</span>
            <span v-else> {{ Number(scope.row.cjjg).toFixed(scope.row.priceScale) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="deliveryClosePl" label="交收盈亏">
          <template slot-scope="scope">
            <span :class="threeTxtColor(Number(scope.row.closePl))" v-if="isHistory"> {{ scope.row.closePl }}</span>
            <span :class="threeTxtColor(Number(util.floatAdd(scope.row.closePl, scope.row.holdClosePl)))" v-else> {{ util.floatAdd(scope.row.closePl, scope.row.holdClosePl) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="fee" label="交收服务费">
          <template slot-scope="scope">
            <!-- tradeType: 6 提前交收的交收服务费显示0 -->
            {{ scope.row.tradeType === 6? 0 : Number(scope.row.fee) | toThousands }}
          </template>
        </el-table-column>
        <el-table-column prop="fee" label="应补货款">
          <template slot-scope="scope">
            <!-- tradeType: 7 到期交收  提前交收的应补货款那列数据实际取交收服务费的值,否则取0 -->
            {{ scope.row.tradeType !== 6? 0 :Number(scope.row.fee) | toThousands }}
          </template>
        </el-table-column>
        <el-table-column prop="deliveryStatus" label="交收状态">
          <template slot-scope="scope">
            已交收
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="交收时间" width="90">
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-row v-if="pageData.total">
        <el-col :span="24" class="paginateWrap">
          <el-pagination
            popper-class="_popStyle"
            :current-page="pageData.currentPage"
            :page-sizes="pageData.pageSizes"
            :page-size="pageData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
/*global http protocol util*/
import { mapGetters } from 'vuex'
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['time', 'isSearch'],
  data() {
    return {
      tableHeight: 0,
      loading: false,
      checked: false,
      tableData: [],
      isHistory: false, // 是否为历史接口
      pageData: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 20,
        currentPage: 1
      },
      // 表格label宽度
      tcdTableWidth: {
        bsFlag: 80,
        ocFlag: 110,
        closePl: 100
      },
      TradeListSum: {
        bsFlag: '',
        cjType: '',
        cjje: null,
        cjjg: null,
        closePl: null,
        commodityCode: '',
        commodityId: null,
        commodityName: '',
        createTime: null,
        fee: null,
        firmId: null,
        holdDetailId: null,
        margin: null,
        minPriceChange: null,
        ocFlag: '',
        orderId: null,
        priceScale: null,
        quantity: null,
        singlePrice: null,
        stampFee: null,
        stampFeeRate: null,
        tqTip: null,
        tradeDay: null,
        tradeId: null,
        tradeType: null,
        updateTime: null
      },
      isNetWrong: false,
      beginTime: [util.formatnewDay(Number(new Date())), util.formatnewDay(Number(new Date()))]
    }
  },
  computed: {
    ...mapGetters(['sessionInfoGetter', 'commodityStrategyGetter'])
  },
  watch: {
    isSearch(val) {
      if (val) {
        this.pageData.currentPage = 1
        this.showData()
      }
    }
  },
  filters: {
    deliveryTypeFormat(e) {
      switch (e) {
        case '5':
          return '协议交收'
        case '6':
          return '提前交收'
        case '7':
          return '到期交收'
        case 'M':
          return '强制交收'
        case 'T':
          return '现货购销交收'
        default:
          return '未知'
      }
    },
    deliveryStatusFormat(e) {
      switch (e) {
        case 'W':
          return '待审核'
        case 'T':
          return '审核通过'
        case 'F':
          return '审核拒绝'
        case 'C':
          return '交收完成'
        case 'U':
          return '已撤销'
        default:
          return '未知'
      }
    }
  },
  created() {
    window.onresize = () => {
      this.$nextTick(() => {
        this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      })
    }
  },
  updated() {
    this.$nextTick(() => {
      this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      this.$refs['tableData'].doLayout()
    })
  },
  mounted() {
    this.showData()
  },
  methods: {
    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.showData()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.showData()
    },
    // 订单展示
    showData() {
      const that = this
      this.loading = true
      let currentProtocol = protocol.queryUserClinchesNew
      if (this.time[0] != this.beginTime[0] || this.time[1] != this.beginTime[1]) {
        currentProtocol = protocol.queryUserClinchHSNew
        currentProtocol.data.startTradeDay = this.time[0]
        currentProtocol.data.endTradeDay = this.time[1]
        currentProtocol.data.page = this.pageData.currentPage
      } else {
        currentProtocol.data.page = this.pageData.currentPage - 1
      }
      // if (this.time) {
      //   // 历史
      //   protocol.queryUserClinchHS.data.startTradeDay = this.time[0]
      //   protocol.queryUserClinchHS.data.endTradeDay = this.time[1]
      // } else {
      //   protocol.queryUserClinchHS.data.startTradeDay = null
      //   protocol.queryUserClinchHS.data.endTradeDay = null
      // }
      currentProtocol.data.size = '' + this.pageData.pageSize
      currentProtocol.data.bsFlag = null
      currentProtocol.data.commodityId = null
      currentProtocol.data.tradeType = [6, 7]
      http.gPostHs(currentProtocol).then(response => {
        if (response.data.code != 0) {
          this.$message({ message: response.data.message })
          this.isNetWrong = true
        } else {
          this.isNetWrong = false
        }
        if (response.data) {
          if (response.data && response.data.code == '0') {
            if (this.time[0] != this.beginTime[0] || this.time[1] != this.beginTime[1]) {
              this.pageData.total = response.data.value.totalElements
              const arr = response.data.value.content
              this.judgeDataType(arr)
              this.isHistory = true
            } else {
              this.pageData.total = response.data.value.totalElements
              const arr = response.data.value.content
              this.judgeDataType(arr)
              this.isHistory = false
            }
            // this.TradeListSum = response.data.value.sumData
          }
        }
        this.loading = false
      }).catch((e) => {
        this.loading = false
        setTimeout(() => {
          that.showData()
        }, 1000)
      })

      // protocol.queryTradeListSum.data = protocol.queryUserClinches.data
      // http.gPost(protocol.queryTradeListSum).then(response => {
      //   if (response.data.code != 0) {
      //     this.$message({ message: response.data.message })
      //   }
      //   if (response.data) {
      //     if (response.data && response.data.code == '0') {
      //       this.TradeListSum = response.data.value
      //     }
      //   }
      // })
    },
    threeTxtColor(price) {
      // 商品价格大于0红色，小于0绿色，等于0灰色
      if (!isNaN(price)) {
        if (price > 0) {
          return 'red-row'
        } else if (price < 0) {
          return 'green-row'
        } else {
          return ''
        }
      }
      return ''
    },
    // 判断数据类型
    judgeDataType(arr) {
      const that = this
      this.each(arr, function(arrIndex) {
        // 判断时间
        that.modifyTime(arrIndex, 'createTime')
        // 判断方向
        that.modifyData(arrIndex, 'bsFlag', 'B', '买入', '卖出')
        that.modifyData(arrIndex, 'ocFlag', 'O', '订立', '转让')
        // 判断委托状态 1-已委托，2-已成交，3-已撤单，4-部分成交，5-部分成交后撤单
        const stateList = ['已委托', '已成交', '已撤单', '部分成交', '部分成交后撤单']
        stateList.forEach((item, index) => {
          that.modifyData(arrIndex, 'orderStatus', index + 1, item)
        })
        arrIndex.textColor = that.threeTxtColor(Number(arrIndex.closePl))
      })
      this.tableData = arr
    },
    // 排序
    sortChange(column, prop, order) {
      let currentProtocol = protocol.param_getDeliveryList
      if (this.time[0] != this.beginTime[0] || this.time[1] != this.beginTime[1]) {
        currentProtocol = protocol.param_getDeliveryListH
      }
      if (column.order == 'ascending') {
        currentProtocol.data.sort[0].direction = 'ASC'
      } else {
        currentProtocol.data.sort[0].direction = 'DESC'
      }
      if (column.column) {
        this.eachSortChange(column.column.property)
        http.gPostHs(currentProtocol).then(response => {
          if (response.data.code != 0) {
            this.$message({ message: response.data.message })
            this.isNetWrong = true
          } else {
            this.isNetWrong = false
          }
          if (response.data) {
            if (response.data && response.data.code == '0') {
              this.pageData.total = response.data.value.totalElements
              const arr = response.data.value.content
              this.judgeDataType(arr)
            }
          }
        })
      }
    },
    // 分项排序
    eachSortChange(str) {
      let currentProtocol = protocol.queryUserClinches
      if (this.time[0] != this.beginTime[0] || this.time[1] != this.beginTime[1]) {
        currentProtocol = protocol.queryUserClinchHS
      }
      return (currentProtocol.data.sort[0].property = str)
    },
    // 单元格颜色
    directionClass(row, column, rowIndex, columnIndex) {
      // 根据字段改变样式
      switch (row.columnIndex) {
        // eslint-disable-next-line no-lone-blocks
        case 4: {
          return this.setStrClass(row.row.bsFlag, '卖出', 'dropColor', 'increaseColor')
        }
        default:
          break
      }
    },
    // 根据语言改变样式
    setLanguageCss() {
      // 防止清缓存后数据消失
      this.$i18n.locale = localStorage.lang || navigator.language.slice(-2).toLowerCase()
      switch (localStorage.lang) {
        case 'en': {
          const tcdTableEnWidth = {
            bsFlag: 120,
            ocFlag: 150,
            closePl: 150
          }
          localStorage.setItem('tcdTableEnWidth', JSON.stringify(tcdTableEnWidth))
          this.tcdTableWidth = JSON.parse(localStorage.tcdTableEnWidth)
        }
          break
        default:
          break
      }
    }

  }

}
</script>
